// /lib contains the transpiled code. It's ignored by git but picked up by
// npm publish. See package.json's "prerelease" and "build" scripts
module.exports = require('./lib/');



//////////////////
// WEBPACK FOOTER
// ./~/react-radio-group/index.js
// module id = 72
// module chunks = 0